import { isNil } from "lodash";

import { ProgressBar } from "app/components/React/ProgressBar/ProgressBar";
import { NO_DATA_SIGN } from "app/filters/const";
import { DEFAULT_DECIMAL, FORMATTERS } from "app/common/benchmark/formatters";
import { CoreWebsiteCell } from "pro-features/components/core cells/src/CoreWebsiteCell/CoreWebsiteCell";

import type { DomainInfo } from "../../types";
import { CellWithLeftPadding } from "../OrganicPaidTable/styledComponents";

import { ProgressBarWrapper, StyledChangeStateCell, PercentageText } from "./styledComponent";

export const renderDomainCell = (domain: DomainInfo) => {
    if (!domain) {
        return NO_DATA_SIGN;
    }

    const { name, favicon, url } = domain;
    return (
        <CellWithLeftPadding>
            <CoreWebsiteCell
                domain={name}
                icon={favicon}
                internalLink={url}
                hideTrackButton
            />
        </CellWithLeftPadding>
    );
};

export const changeIndicatorComponent = (change?: number, changePresentation?: string, align?: string) => {
    const hasValue = !isNil(change);
    const formattedChange = FORMATTERS.percent(change, DEFAULT_DECIMAL);

    const value = {
        change: formattedChange,
        ...(!hasValue && { changeState: changePresentation ?? NO_DATA_SIGN }),
    };

    return (
        <StyledChangeStateCell
            value={value}
            undefinedSign={NO_DATA_SIGN}
            isPercentage={true}
            $align={align}
        />
    );
};

export const renderChangeCell = (change?: number, changePresentation?: string, align?: string) => {
    const hasValue = !isNil(change);
    const formattedChange = FORMATTERS.percent(change, DEFAULT_DECIMAL);

    const value = {
        change: formattedChange,
        ...(!hasValue && { changeState: changePresentation ?? NO_DATA_SIGN }),
    };

    return (
        <StyledChangeStateCell
            value={value}
            undefinedSign={NO_DATA_SIGN}
            isPercentage={true}
            $align={align}
        />
    );
};
export const renderProgressBarCell = ({
    leftValue,
    rightValue,
    percentageValue,
}: {
    leftValue: string;
    rightValue: string;
    percentageValue: number;
}) => {
    return (
        <ProgressBarWrapper>
            <PercentageText>{leftValue}</PercentageText>
            <ProgressBar
                width={percentageValue}
                className="u-full-width"
                isCompare={true}
                height={8}
            />
            <PercentageText>{rightValue}</PercentageText>
        </ProgressBarWrapper>
    );
};
